/*jshint esversion: 6 */

import React from 'react';
import Select from 'react-select'


export default class QuizWinner extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            value: this.props.value
        };
    }

    componentWillReceiveProps(newProps) {
        this.setState({value: newProps.value});
    }

    render(){
        return(
            <div>
                <p>Select the winner for the quiz.</p>
                <Select value={this.state.value || ''} onChange={value => this.props.onChange({value})}  options={this.props.options} />
            </div>
        )
    }
}

const input = {
    width: '100%',
    border: '1px solid #cccccc',
    margin: '5px 0'
};





